/**
 * Copy FROM Standards Button Component
 * Button that appears in the drawer when other locations have configured standards
 */

import React from 'react';
import { Copy } from 'lucide-react';

export const CopyFromStandardsButton = ({ onCopyFrom, disabled = false }) => {
  return (
    <div className="bg-gradient-to-r from-[#61b8e7]/5 to-transparent border-t border-b border-[#61b8e7]/20 px-8 py-3">
      <button
        type="button"
        onClick={onCopyFrom}
        disabled={disabled}
        className="w-full py-3 px-4 border-2 border-dashed border-[#61b8e7] rounded-lg text-[#61b8e7] hover:bg-[#61b8e7]/5 hover:border-solid transition-all font-['Roboto:Medium',sans-serif] text-[14px] flex items-center justify-center gap-2.5 group disabled:opacity-50 disabled:cursor-not-allowed"
      >
        <Copy className="w-4.5 h-4.5 group-hover:scale-110 transition-transform" />
        <span>Copy FROM another area with configured standards</span>
      </button>
      <p className="font-['Roboto:Regular',sans-serif] text-[12px] text-gray-500 text-center mt-2">
        Save time by copying existing configuration
      </p>
    </div>
  );
};
